import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { Workspace } from '@/hooks/api/models';

/**
 * 0140. ワークスペース情報編集
 * [PUT] /workspaces/:identifier
 */
type Props = {
  name: string;
  identifier: string;
  to_identifier: string;
  closing_month: number;
  logo_image: string;
};
export const editWorkspace = (props: Props): Promise<Workspace> => {
  return axios.put(`/api/workspaces/${props.identifier}`, props);
};

export const useEditWorkspaceBasic = () => {
  return useMutation({
    mutationFn: editWorkspace,
  });
};
